import React from 'react';
import { useTranslation } from 'react-i18next';
import { H3 } from '@components/Typography/Typography';

import { OpenPlantsBoost } from '@/components/OpenPlantsBoost/OpenPlantsBoost';

import CardFactories from './Card/CardFactories';

import css from './styles.module.scss';

const PageBody: React.FC = () => {
  const { t } = useTranslation();

  const activeHelp = JSON.parse(localStorage.getItem('help') || 'true');

  return (
    <div
      style={{
        paddingTop: 'var(--header-height)',
      }}
      className={css.body}
    >
      <div className="flex items-center justify-between">
        <H3
          style={{ visibility: activeHelp ? 'hidden' : 'visible' }}
          weight="bold"
        >
          {t('Select factory')}
        </H3>
        <OpenPlantsBoost kind="goods" />
      </div>
      <div className="tabs__list pb-2">
        <CardFactories />
      </div>
    </div>
  );
};

export default PageBody;
